/* PDP variant price update — defensive patch
   Project: Veryplants CRO fixes (Apr 2026)

   Theme uses pubsub.js + constants.js with PUB_SUB_EVENTS.variantChange.
   product-info.js renders the section on variant change, which should already update
   the price. This patch is defensive: subscribes to the same event and force-updates
   the price elements + Seal Subscriptions price if present.

   Safe to remove if QA confirms the underlying behaviour is working.
*/

(function () {
  if (window.__veryplantsPdpPricePatchLoaded) return;
  window.__veryplantsPdpPricePatchLoaded = true;

  function init() {
    if (typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS) {
      // pubsub not loaded yet, retry shortly.
      return setTimeout(init, 200);
    }

    window.subscribe(window.PUB_SUB_EVENTS.variantChange, (data) => {
      const variant = data && (data.data?.variant || data.variant);
      if (!variant) return;
      updatePrices(variant);
    });

    // Also catch the option-change event for snappier updates before section render completes.
    window.subscribe(window.PUB_SUB_EVENTS.optionValueSelectionChange, () => {
      const idInput = document.querySelector('product-info form[action*="/cart/add"] input[name="id"]');
      if (!idInput) return;
      const id = Number(idInput.value);
      if (!id) return;
      // Look up product JSON if the form has handle data.
      const form = idInput.closest('form');
      const productInfo = form?.closest('product-info');
      const handle = productInfo?.dataset.url?.split('/').pop()?.split('?')[0];
      if (!handle) return;
      fetch(`/products/${handle}.js`)
        .then((r) => r.json())
        .then((p) => {
          const variant = p.variants.find((v) => v.id === id);
          if (variant) updatePrices(variant);
        })
        .catch(() => {});
    });
  }

  function updatePrices(variant) {
    const priceCents = variant.price;
    const compareCents = variant.compare_at_price;

    // Main displayed price.
    document.querySelectorAll(
      '.price-item--regular, .price__regular .price-item, [data-product-price]'
    ).forEach((el) => {
      el.textContent = formatMoney(priceCents);
    });

    // Compare-at price.
    document.querySelectorAll(
      '.price-item--sale, .price__sale .price-item, [data-compare-price]'
    ).forEach((el) => {
      if (compareCents && compareCents > priceCents) {
        el.textContent = formatMoney(compareCents);
      }
    });

    // Seal Subscriptions widget price (defensive — class name may vary by version).
    document.querySelectorAll(
      '.seal-subscriptions-widget .seal-subscriptions-product-price, .seal-subscriptions-price, [data-subscription-price]'
    ).forEach((el) => {
      // Don't know the discount% reliably from JS — best effort: re-fetch widget render.
      // If the widget is rendering stale, the simplest fix is to re-call its render method.
      if (window.sealSubscriptions && typeof window.sealSubscriptions.refresh === 'function') {
        try { window.sealSubscriptions.refresh(); } catch (e) {}
      }
    });

    document.dispatchEvent(
      new CustomEvent('veryplants:price-updated', { detail: { variant, priceCents } })
    );
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      try {
        return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
      } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
